import { ReactNode } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";

import EmptyState from "@/components/emptyState/EmptyState";

const ErrorFallback = () => {
  const { t } = useTranslation();
  return <EmptyState title={t("emptyState.globalWrong")} text={t("emptyState.historyText")} />;
};

const WidgetErrorBoundary = ({ children }: { children: ReactNode }) => (
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>
);

export default WidgetErrorBoundary;
